import { Component, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { AppSettingsModel, Asset } from 'src/app/Modelo/AppSettings.Model';
import { SettingsService } from 'src/app/servicios/settings.service';

@Component({
  selector: 'app-swiper-products',
  templateUrl: './swiper-products.component.html',
  styleUrls: ['./swiper-products.component.scss']
})
export class SwiperProductsComponent implements OnInit {
  private _appSettings: AppSettingsModel;
  public ConfiguracionSlider: SwiperOptions = {

		init: true,
		speed: 500,
    slidesPerView:  2,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: "#product-button-next",
      prevEl: "#product-button-prev",
    },
    breakpoints: {
      // when window width is >= 450px
      450: {
        slidesPerView: 3,
      },
      // when window width is >= 650px
      650: {
        slidesPerView: 4,
      }
    },
    autoplay: {
      delay: 1500,
      disableOnInteraction: false,
      waitForTransition: true
    },
	};
  
  get products(): Array<Asset> {
    return this._appSettings?.swiperProducts?.filter(b => b.visible) ?? new Array<Asset>();
  }

  constructor(private _appSettingsService: SettingsService) { }

  ngOnInit(): void {
    this._appSettingsService.get().then((appSettings: AppSettingsModel) => this._appSettings = appSettings);
  }

}
